import React, { useEffect, useState } from "react";
import SaleInvoice from "../pages/sale/SaleInvoice";
import { BusinessSettingsProvider } from "./sidebar/BusinessSettingsContext";

const EVENT = "dukanbuddy:auto-share-invoice";
const PRINT_EVENT = "dukanbuddy:auto-print-invoice";

// Lets the sale form close immediately while the invoice PDF is generated
// and sent in the background by a host mounted at the app root.
export const queueInvoiceAutoShare = (sale) =>
  window.dispatchEvent(new CustomEvent(EVENT, { detail: sale }));

// Prints the same invoice shown in the sale preview (uses the Windows printer).
export const queueInvoiceAutoPrint = (sale) =>
  window.dispatchEvent(new CustomEvent(PRINT_EVENT, { detail: sale }));

const AutoInvoiceShareHost = () => {
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    const onQueue = (e) => {
      const sale = e.detail;
      if (!sale?.sellUuid) return;
      setJobs((prev) => [...prev, { id: `${sale.sellUuid}-${Date.now()}`, sale }]);
    };
    const onPrint = (e) => {
      const sale = e.detail;
      if (!sale?.sellUuid) return;
      setJobs((prev) => [
        ...prev,
        { id: `${sale.sellUuid}-print-${Date.now()}`, sale, print: true },
      ]);
    };
    window.addEventListener(EVENT, onQueue);
    window.addEventListener(PRINT_EVENT, onPrint);
    return () => {
      window.removeEventListener(EVENT, onQueue);
      window.removeEventListener(PRINT_EVENT, onPrint);
    };
  }, []);

  if (!jobs.length) return null;

  return jobs.map(({ id, sale, print }) => (
    <div
      key={id}
      aria-hidden="true"
      style={{ position: "fixed", left: "-10000px", top: 0, width: "210mm" }}
    >
      <BusinessSettingsProvider businessUuid={sale.bussinessUuid}>
        <SaleInvoice
          item={sale}
          close={() => {}}
          autoShare={!print}
          autoPrint={!!print}
          onAutoShareDone={() => setJobs((prev) => prev.filter((j) => j.id !== id))}
        />
      </BusinessSettingsProvider>
    </div>
  ));
};

export default AutoInvoiceShareHost;
